<!-- Start Main Page Section -->
<div class="ecb-page">

  <!-- Start Header Section -->
  <header class="ecb-header">

    <!-- Start Header Main Content Section -->
    <div class="ecb-shell h-100 d-flex align-items-center justify-content-between">

      <!-- Start Header Logo Section -->
      <a routerLink="/" class="ecb-logo" (click)="closeHeaderMenus()">
        <span class="ecb-logo-mark">
          <img src="assets/images/logo/logo-white.webp" alt="ECB Training" class="ecb-web-header-logo">
        </span>


      </a>

      <!-- End Header Logo Section -->


      <!-- Start Desktop Navigation Section -->
      <nav class="d-none d-lg-flex align-items-center gap-1">

        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeHeaderMenus()">
          Home
        </a>

        <a routerLink="/course-qualifications" routerLinkActive="active" (click)="closeHeaderMenus()">
          Qualifications
        </a>

        <a [routerLink]="['/course-short']" [queryParams]="{ type: 'all_short_courses' }"
          [class.active]="isRegularShortCourseActive()" (click)="closeHeaderMenus()">
          Short Courses
        </a>
        <a routerLink="/course-voc" routerLinkActive="active" (click)="closeHeaderMenus()">
          VOC's
        </a>
        <a routerLink="/course-hsr" routerLinkActive="active" (click)="closeHeaderMenus()">
          HSR
        </a>

        <a routerLink="/corporate" routerLinkActive="active" (click)="closeHeaderMenus()">
          Corporate
        </a>

        <a routerLink="/about-us" routerLinkActive="active" (click)="closeHeaderMenus()">
          About Us
        </a>

        <a routerLink="/contact-us" routerLinkActive="active" (click)="closeHeaderMenus()">
          Contact Us
        </a>

        <!-- Start GTO Main Navigation Section -->
        <!-- Display GTO as its own main navigation item as required. -->
        <a routerLink="/gto" routerLinkActive="active" (click)="closeHeaderMenus()">
          GTO
        </a>
        <!-- End GTO Main Navigation Section -->

        <a routerLink="/breaking-the-cycle" routerLinkActive="active" (click)="closeHeaderMenus()">
          Community
        </a>

        <!-- Start Community Dropdown Navigation Section -->
        <!-- Keep Community as a main menu and place Breaking the Cycle inside it. -->
        <div class="ecb-community-menu-wrap" *ngIf="false">
          <!-- Toggle the Community sub navigation. -->
          <button type="button" class="ecb-community-menu-button" [class.active]="isCommunitySectionActive()"
            [attr.aria-expanded]="showCommunityDropdown" (click)="toggleCommunityDropdown()">
            Community
            <i class="fa ms-1" [ngClass]="showCommunityDropdown ? 'fa-angle-up' : 'fa-angle-down'"></i>
          </button>

          <!-- Show the Community dropdown only when it has been opened. -->
          <div class="ecb-community-dropdown" *ngIf="showCommunityDropdown">
            <!-- Navigate to the Breaking the Cycle community program page. -->
            <a routerLink="/breaking-the-cycle" routerLinkActive="active" (click)="closeHeaderMenus()">
              <i class="fa fa-refresh"></i>
              <span>
                <strong>Breaking the Cycle</strong>
                <small>Community Services program</small>
              </span>
            </a>
          </div>
        </div>
        <!-- End Community Dropdown Navigation Section -->

        <!-- Start Training Dropdown Navigation Section -->
        <a routerLink="/hsr-training" routerLinkActive="active" (click)="closeHeaderMenus()">
          Training
        </a>

        <!-- Keep course-specific training pages inside the Training menu. -->
        <div class="ecb-training-menu-wrap" *ngIf="false">
          <!-- Toggle the Training sub navigation. -->
          <button type="button" class="ecb-training-menu-button" [class.active]="isTrainingSectionActive()"
            [attr.aria-expanded]="showTrainingDropdown" (click)="toggleTrainingDropdown()">
            Training
            <i class="fa ms-1" [ngClass]="showTrainingDropdown ? 'fa-angle-up' : 'fa-angle-down'"></i>
          </button>

          <!-- Show the Training dropdown only when it has been opened. -->
          <div class="ecb-training-dropdown" *ngIf="showTrainingDropdown">
            <!-- Navigate to the HSR Training page. -->
            <a routerLink="/hsr-training" routerLinkActive="active" (click)="closeHeaderMenus()">
              <i class="fa fa-shield"></i>
              <span>
                <strong>HSR Training</strong>
                <small>WorkSafe Victoria approved training</small>
              </span>
            </a>
          </div>
        </div>
        <!-- End Training Dropdown Navigation Section -->



        <a routerLink="/course-booking" routerLinkActive="active" (click)="closeHeaderMenus()">
          Booking
        </a>

      </nav>
      <!-- End Desktop Navigation Section -->


      <!-- Start Header Action Section -->
      <div class="header-actions">

        <!-- Start Cart Navigation Section -->
        <a routerLink="/cart"  class="ecb-cart-nav" (click)="closeHeaderMenus()">
          <i class="fa fa-shopping-cart"></i>

          <span>Cart</span>

          <strong>
            {{ cartCount }}
          </strong>
        </a>
        <!-- End Cart Navigation Section -->


        <!-- Start Login Dropdown Section -->
        <div class="login-menu-wrap">

          <!-- Start Login Button Section -->
          <button type="button" class="ecb-login-btn" [attr.aria-expanded]="showLoginDropdown"
            (click)="toggleLoginDropdown()">
            LOGIN

            <i class="fa ms-1" [ngClass]="
                showLoginDropdown
                  ? 'fa-angle-up'
                  : 'fa-angle-down'
              "></i>
          </button>
          <!-- End Login Button Section -->


          <!-- Start Login Dropdown Menu Section -->
          <div class="login-dropdown" *ngIf="showLoginDropdown">

            <a routerLink="/admin/login" (click)="closeHeaderMenus()">
              <i class="fa fa-user-secret"></i>

              <span>
                Admin Login
              </span>

              <small>
                Manage courses, dates and orders
              </small>
            </a>

            <a routerLink="/auth/customer-login" (click)="closeHeaderMenus()">
              <i class="fa fa-user"></i>

              <span>
                Customer Login
              </span>

              <small>
                Book courses and view purchases
              </small>
            </a>

            <a routerLink="/auth/register" (click)="closeHeaderMenus()">
              <i class="fa fa-user-plus"></i>

              <span>
                Create Account
              </span>

              <small>
                Register and continue booking
              </small>
            </a>

          </div>
          <!-- End Login Dropdown Menu Section -->

        </div>
        <!-- End Login Dropdown Section -->


        <!-- Start Mobile Navigation Button Section -->
        <button type="button" class="ecb-mobile-nav-button d-lg-none" aria-label="Toggle mobile navigation"
          [attr.aria-expanded]="showMobileNavigation" (click)="toggleMobileNavigation()">
          <i class="fa" [ngClass]="
              showMobileNavigation
                ? 'fa-times'
                : 'fa-bars'
            "></i>
        </button>
        <!-- End Mobile Navigation Button Section -->

      </div>
      <!-- End Header Action Section -->

    </div>
    <!-- End Header Main Content Section -->


    <!-- Start Mobile Navigation Section -->
    <nav class="ecb-mobile-navigation d-lg-none" *ngIf="showMobileNavigation">




      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeHeaderMenus()">
        Home
      </a>

      <a routerLink="/course-qualifications" routerLinkActive="active" (click)="closeHeaderMenus()">
        Qualifications
      </a>

      <a [routerLink]="['/course-short']" [queryParams]="{ type: 'UOC' }" [class.active]="isRegularShortCourseActive()"
        (click)="closeHeaderMenus()">
        Short Courses
      </a>
      <a routerLink="/course-voc" routerLinkActive="active" (click)="closeHeaderMenus()">
        VOC's
      </a>
      <a routerLink="/course-hsr" routerLinkActive="active" (click)="closeHeaderMenus()">
        HSR
      </a>

      <a routerLink="/corporate" routerLinkActive="active" (click)="closeHeaderMenus()">
        Corporate
      </a>

      <a routerLink="/about-us" routerLinkActive="active" (click)="closeHeaderMenus()">
        About Us
      </a>

      <a routerLink="/contact-us" routerLinkActive="active" (click)="closeHeaderMenus()">
        Contact Us
      </a>


      <!-- Display GTO as a main menu item in mobile navigation too. -->
      <a routerLink="/gto" routerLinkActive="active" (click)="closeHeaderMenus()">
        <span>GTO</span>
      </a>
      <!-- End Mobile GTO Main Navigation Section -->

      <!-- Start Mobile Community Sub Navigation Section -->
      <a routerLink="/breaking-the-cycle" routerLinkActive="active" (click)="closeHeaderMenus()">
        <span>Community</span>
      </a>

      <!-- Toggle the Community sub navigation on tablet and mobile. -->
      <button *ngIf="false" type="button" class="ecb-mobile-community-toggle"
        [class.active]="isCommunitySectionActive()" [attr.aria-expanded]="showMobileCommunitySubNavigation"
        (click)="toggleMobileCommunitySubNavigation()">
        <span><i class="fa fa-users"></i> Community</span>
        <i class="fa" [ngClass]="showMobileCommunitySubNavigation ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </button>

      <!-- Show the Community child links only when the mobile Community menu is open. *ngIf="showMobileCommunitySubNavigation" -->
      <div *ngIf="false" class="ecb-mobile-community-subnav">
        <!-- Navigate to the Breaking the Cycle community program page. -->
        <a routerLink="/breaking-the-cycle" routerLinkActive="active" (click)="closeHeaderMenus()">
          Breaking the Cycle
        </a>
      </div>
      <!-- End Mobile Community Sub Navigation Section -->

      <a routerLink="/hsr-training" routerLinkActive="active" (click)="closeHeaderMenus()">
        <span>Training</span>
      </a>

      <!-- Start Mobile Training Sub Navigation Section -->
      <!-- Toggle the Training sub navigation on tablet and mobile. -->
      <button *ngIf="false" type="button" class="ecb-mobile-training-toggle" [class.active]="isTrainingSectionActive()"
        [attr.aria-expanded]="showMobileTrainingSubNavigation" (click)="toggleMobileTrainingSubNavigation()">
        <span><i class="fa fa-graduation-cap"></i> Training</span>
        <i class="fa" [ngClass]="showMobileTrainingSubNavigation ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </button>

      <!-- Show only the pages that belong under Training. *ngIf="showMobileTrainingSubNavigation"-->
      <div *ngIf="false" class="ecb-mobile-training-subnav">
        <!-- Navigate to the HSR Training page. -->
        <a routerLink="/hsr-training" routerLinkActive="active" (click)="closeHeaderMenus()">HSR Training</a>
      </div>
      <!-- End Mobile Training Sub Navigation Section -->



      <a routerLink="/course-booking" routerLinkActive="active" (click)="closeHeaderMenus()">
        Booking
      </a>
    </nav>
    <!-- End Mobile Navigation Section -->

  </header>
  <!-- End Header Section -->


  <!-- Start Routed Content Section -->
  <router-outlet></router-outlet>
  <!-- End Routed Content Section -->


  <!-- Start Footer Section -->
  <footer id="contact" class="ecb-web-footer">

    <!-- Start Footer Main Content Section -->
    <div class="ecb-web-footer-main">
      <div class="container">
        <div class="row g-4">

          <!-- Start Footer Company Section -->
          <div class="col-12 col-md-6 col-lg-3">
            <div class="ecb-web-footer-company">

              <img src="assets/images/logo/logo-white.webp" alt="ECB Training" class="ecb-web-footer-logo">

              <p>
                Australia's trusted training provider delivering
                nationally recognised courses across multiple industries.
              </p>

              <!-- Start Footer Social Media Section -->
              <!--  <div class="ecb-web-footer-social-list">

                <a href="#" aria-label="Facebook">
                  <i class="bi bi-facebook"></i>
                </a>

                <a href="#" aria-label="Instagram">
                  <i class="bi bi-instagram"></i>
                </a>

                <a href="#" aria-label="LinkedIn">
                  <i class="bi bi-linkedin"></i>
                </a>

                <a href="#" aria-label="YouTube">
                  <i class="bi bi-youtube"></i>
                </a>

              </div> -->
              <!-- End Footer Social Media Section -->

            </div>
          </div>
          <!-- End Footer Company Section -->


          <!-- Start Footer Course Link Section -->
          <div class="col-6 col-md-3 col-lg-3">
            <div class="ecb-web-footer-link-group">

              <h3>Courses</h3>

              <a *ngFor="let link of courseLinks; trackBy: trackByLabel" [routerLink]="[link.url]"
                [queryParams]="link.queryParams">

                {{ link.label }}

              </a>

            </div>
          </div>
          <!-- End Footer Course Link Section -->


          <!-- Start Footer Quick Link Section -->
          <div class="col-6 col-md-3 col-lg-3">
            <div class="ecb-web-footer-link-group">

              <h3>Quick Links</h3>

              <a *ngFor="let link of quickLinks; trackBy: trackByLabel" [routerLink]="[link.url]"
                [queryParams]="link.queryParams">
                {{ link.label }}
              </a>

            </div>
          </div>
          <!-- End Footer Quick Link Section -->



          <!-- Start Footer Contact Section -->
          <div class="col-12 col-md-6 col-lg-3">
            <div class="ecb-web-footer-contact">

              <h3>Get in Touch</h3>



              <p class="ecb-web-footer-address">
                <i class="bi bi-clock-fill"></i>
                <span>
                  07:00 – 16:30 Monday to Friday, <br>
                  Saturday and Sunday by appointment
                </span>
              </p>

              <p class="ecb-web-footer-address">
                <i class="bi bi-geo-alt-fill"></i>

                <span>
                  598 Kororoit Creek Rd,<br>
                  Altona North, VIC, 3025
                </span>

                <span class="ecb-web-footer-contact">
                  <a href="tel:1300322486">
                    <i class="bi bi-telephone-fill"></i>
                    1300 322 486
                  </a>

                  <a href="mailto:melbourne@ecbtraining.com.au">
                    <i class="bi bi-envelope-fill"></i>
                 
                    melbourne&#64;ecbtraining.com.au
                  </a>
                </span>
              </p>

              <p class="ecb-web-footer-address">
                <i class="bi bi-geo-alt-fill"></i>

                <span>
                   44 McMinn Street, <br>
                  Darwin, NT. 0800,
                </span>

                <span class="ecb-web-footer-contact">
                  <a href="tel:0879054026">
                    <i class="bi bi-telephone-fill"></i>
                   08 7905 4026
                  </a>

                  <a href="mailto:darwin@ecbtraining.com.au">
                    <i class="bi bi-envelope-fill"></i>
                    darwin&#64;ecbtraining.com.au
                  </a>
                </span>
              </p>

              
            </div>

          </div>
          <!-- End Footer Contact Section -->

        </div>
      </div>
    </div>
    <!-- End Footer Main Content Section -->


    <!-- Start Footer Copyright Section -->
    <div class="ecb-web-footer-bottom">
      <div class="container">
        <div class="row align-items-center g-2">

          <div class="col-12 col-md-6 text-center text-md-start">
            <p>
              © {{ currentYear }} ECB Training. All Rights Reserved.
            </p>
          </div>
          <div class="col-12 col-md-1 text-center text-md-start">
            <a style="font-size: 1px;color:#1f1f1c;" href="https://www.iitcglobal.com/"> IITC Global Pty Ltd </a>
            <a style="font-size: 1px;color:#1f1f1c;" href="https://iitcglobal.net/"> IITC Global Pty Ltd </a>
          </div>

          <div class="col-12 col-md-5 text-center text-md-end">
            <p>
              RTO No: 41369 | Nationally Recognised Training
            </p>

          </div>

        </div>
      </div>
    </div>
    <!-- End Footer Copyright Section -->

  </footer>
  <!-- End Footer Section -->

</div>
<!-- End Main Page Section -->